module.exports = __webpack_public_path__ + "img/transfer-progress.d96ea96d.svg";